import { render, staticRenderFns } from "./DnSliderAlternative.vue?vue&type=template&id=3ad8ce9c&scoped=true&"
import script from "./DnSliderAlternative.vue?vue&type=script&lang=js&"
export * from "./DnSliderAlternative.vue?vue&type=script&lang=js&"
import style0 from "./DnSliderAlternative.vue?vue&type=style&index=0&id=3ad8ce9c&lang=scss&scoped=true&"
import style1 from "./DnSliderAlternative.vue?vue&type=style&index=1&id=3ad8ce9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad8ce9c",
  null
  
)

export default component.exports